import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { EMPTY, Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { BroadcastingBasic } from 'src/app/models/broadcastings-models/broadcasting-basic.model';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-broadcastings-broadcasting-resume-card',
  templateUrl: './broadcastings-broadcasting-resume-card.component.html',
  styleUrls: ['./broadcastings-broadcasting-resume-card.component.scss']
})
export class BroadcastingsBroadcastingResumeCardComponent implements OnInit, OnDestroy {

  @Input() broadcasting: BroadcastingBasic;
  @Input() viewDisposition;
  updateBroadcastingStatusSubscription: Subscription;
  deleteBroadcastingSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
              private broadcastingsService: BroadcastingsService,
              private snackbarService: SnackBarService,
              private router: Router,
              private dialog: MatDialog) { }

  ngOnInit() {
  }

  public toggleStatus() {
    this.updateBroadcastingStatusSubscription = this.broadcastingsService.updateBroadcastingStatus(this.broadcasting.BroadcastingInternalId).pipe(
      tap(o => this.broadcasting.Active = o['data']['status']),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['/broadcastings/broadcasting', this.broadcasting.BroadcastingInternalId]);
    }
  }

  public deleteBroadcasting() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['turns-page.delete location', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteBroadcastingSubscription = this.broadcastingsService.deleteBroadcasting(this.broadcasting.BroadcastingInternalId).pipe(
          tap(o => this.broadcastingsService.refreshBroadcastings()),
          catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
        ).subscribe();
      }
    });
  }

  ngOnDestroy() {
    if (this.deleteBroadcastingSubscription) { this.deleteBroadcastingSubscription.unsubscribe(); }
  }

}
